import { Location } from '@angular/common';
import { AuthService } from './../../services/auth.service';
import { ClientesComponent } from './../clientes/clientes.component';
import { ClientesService } from './../../services/clientes.service';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import {Router, ActivatedRoute, Params, ActivatedRouteSnapshot, RouterLinkWithHref} from '@angular/router';

@Component({
  selector: 'app-direccion',
  templateUrl: './direccion.component.html',
  styleUrls: ['./direccion.component.css']
})
export class DireccionComponent implements OnInit {

  @ViewChild("mensaje") mensaje: ElementRef;
  codigo;
  direccion:{}={};
  

  constructor(private location:Location, private renderer:Renderer2, private auth:AuthService, private clientesService:ClientesService, private router:Router, private activatedRoute:ActivatedRoute) {
    
    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
    
    });
  }

  ngOnInit() {
    

    
      if(this.codigo!="nuevo"){
        this.cargarDireccion();
      }else{ 
        this.resetDireccion();
      }
        
  }

  cargarDireccion(){
    this.clientesService.getDireccion(this.codigo)
    .subscribe(resp=>{
      this.direccion=resp;
    });
  }

  existeDireccion(){
    let devolver:boolean=false;
    for(let j=0;j<this.clientesService.direcciones.length;j++){
      if(this.codigo==this.clientesService.direcciones[j].CDcodigo){
        devolver=true;
      }
    }
    return devolver;
  }

  guardarDireccion(){
    if(this.codigo=="nuevo"){
      this.clientesService.insertDireccion(this.direccion, this.clientesService.clienteActual["CLcodigo"])
      .subscribe(resp=>{
        let texto=this.renderer.createText(resp["mensaje"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensaje.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensaje.nativeElement, "text-danger");
        }
        this.renderer.appendChild(this.mensaje.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensaje.nativeElement,texto);
          this.location.back();
        }, 1000);
        
        
      });
      
    }else{
      this.clientesService.updateDireccion(this.direccion, this.codigo)
      .subscribe(resp=>{
        
        let texto=this.renderer.createText(resp["mensaje"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensaje.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensaje.nativeElement, "text-danger");
        }

        this.renderer.appendChild(this.mensaje.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensaje.nativeElement,texto);
        }, 2000);
      });
    }
    
  }

  resetDireccion(){
    this.direccion={
      CDdireccion:"",
      CDcodpostal:"",
      CDpoblacion:"",
      CDprovincia:"",
      CDpais:"",
      CDtfno:"",
      CDmovil:"",
      CDfax:""
    };
  }

  
  goBack(){
    this.location.back();

  }
}




// WEBPACK FOOTER //
// ./src/app/components/direccion/direccion.component.ts